import r from "./_baseIsMap.js";
import p from "./_baseUnary.js";
import a from "./_nodeUtil.js";
var o = a && a.isMap, s = o ? p(o) : r;
const m = s;
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isMap.js
// module id = 1564
// module chunks = 67